import type { RouteObject } from "react-router-dom";
import { Navigate, useParams } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductDetail from "../pages/product/page";
import CategoryPage from "../pages/category/page";
import About from "../pages/about/page";
import FAQ from "../pages/faq/page";
import Blog from "../pages/blog/page";
import BlogPost from "../pages/blog/post/page";
import Privacy from "../pages/privacy/page";

function LegacyProductRedirect() {
  const { id } = useParams();
  return <Navigate to={`/produkt/${id}`} replace />;
}

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/sadler", element: <CategoryPage /> },
  { path: "/ridebeklaedning", element: <CategoryPage /> },
  { path: "/staldinventar", element: <CategoryPage /> },
  { path: "/pleje", element: <CategoryPage /> },
  { path: "/foder", element: <CategoryPage /> },
  { path: "/hestetilbehor", element: <CategoryPage /> },
  { path: "/saddles", element: <Navigate to="/sadler" replace /> },
  { path: "/riding-clothes", element: <Navigate to="/ridebeklaedning" replace /> },
  { path: "/stable-equipment", element: <Navigate to="/staldinventar" replace /> },
  { path: "/grooming", element: <Navigate to="/pleje" replace /> },
  { path: "/feed", element: <Navigate to="/foder" replace /> },
  { path: "/about", element: <About /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:slug", element: <BlogPost /> },
  { path: "/produkt/:id/:slug", element: <ProductDetail /> },
  { path: "/produkt/:id", element: <ProductDetail /> },
  { path: "/product/:id", element: <LegacyProductRedirect /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
